// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__24V00","select":"Header_select__1qw33","clinic":"Header_clinic__3_sWl"};